import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/translation/publish/translation.publish.mutation.gql"
import type {
  TranslationPublishMutation,
  TranslationPublishMutationVariables,
} from "@/v2-backoffice-client/translation/publish/__types__/translation.publish.mutation"

type Options = MutationHookOptions<
  TranslationPublishMutation,
  TranslationPublishMutationVariables
>

export function useTranslationPublishMutation(options?: Options) {
  return useMutation<
    TranslationPublishMutation,
    TranslationPublishMutationVariables
  >(mutation, options)
}
